import { ObjectId } from './ObjectId'

export type NullObjectId = '000000000000000000000000'
export const nullObjectIdString: NullObjectId = '000000000000000000000000'
export const nullObjectId = new ObjectId(nullObjectIdString)

export const isNullObjectId = (id: string | ObjectId | NullObjectId): id is NullObjectId => {
    return id.toString() === nullObjectIdString
}
